import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { TabType } from '../types';

interface TabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export const Tabs: React.FC<TabsProps> = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(
      'flex',
      'overflow-x-auto scrollbar-hide',
      'gap-3',
      'p-1'
    )}>
      <button
        onClick={() => onTabChange('available')}
        className={clsx(
          'rounded-full transition-all whitespace-nowrap',
          'px-3',
          'py-2 sm:py-3',
          'font-medium sm:font-bold',
          'text-[16px] leading-[22px]',
          activeTab === 'available'
            ? 'bg-N900 text-white'
            : 'bg-N200 text-N700 hover:text-N900'
        )}
      >
        {t('js.features.marketplace.home.find_your_next_home_section.available_homes')}
      </button>
      <button
        onClick={() => onTabChange('coming-soon')}
        className={clsx(
          'rounded-full transition-all whitespace-nowrap',
          'px-3',
          'py-2 sm:py-3',
          'font-medium sm:font-bold',
          'text-[16px] leading-[22px]',
          activeTab === 'coming-soon'
            ? 'bg-N900 text-white'
            : 'bg-N200 text-N700 hover:text-N900'
        )}
      >
        {t('js.features.marketplace.home.find_your_next_home_section.launching_soon')}
      </button>
    </div>
  );
};
